module.exports = __webpack_public_path__ + "images/pages/lp/pattern_bg_stripe_blue_ee449683f7c78a35d53c23978c2cb041.png";